import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <section className="fi-wrapper">
      <div className="fi-container">
        {/* Cột 1: Logo + liên hệ */}
        <div className="fi-col">
          {/* ==== ĐỔI ĐƯỜNG DẪN LOGO TẠI ĐÂY ==== */}

          {/* ===================================== */}

          <h3 className="fi-heading">CÔNG TY TNHH THUẬN ĐIỆN LẠNH SÀI GÒN</h3>
          <h4>MST: 0317106118</h4>

          <p className="fi-line">
            <span className="fi-icon">📍</span>
            <span>
              <strong>Địa chỉ:</strong> 73 Đường Tân Hiệp 9, Ấp Thới Tây 1, Xã
              Tân Hiệp, Huyện Hóc Môn, Thành phố Hồ Chí Minh, Việt Nam
            </span>
          </p>

          <p className="fi-line">
            <span className="fi-icon">📞</span>
            <span>
              <strong>Hotline:</strong> 0384.063.247
            </span>
          </p>

          <p className="fi-line">
            <span className="fi-icon">✉️</span>
            <span>
              <strong>Email:</strong> Xecuocmientay227@gmail.com
            </span>
          </p>
        </div>

        {/* Cột 2: Phạm vi hoạt động + chính sách */}
        <div className="fi-col">
          <h3 className="fi-heading">Phạm vi hoạt động</h3>

          <h4 className="fi-subheading">Mọi khu vực TP.HCM</h4>
          <p className="fi-text">
            Điện lạnh Sài Gòn hỗ trợ dịch vụ tại các quận, huyện tại TP.HCM, bao
            gồm Quận 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, Tân Bình, Tân Phú,
            Bình Thạnh, Bình Chánh, Gò Vấp, Phú Nhuận, Bình Tân, và Nhà Bè.
          </p>

          <h4 className="fi-subheading">Các tỉnh lân cận</h4>
          <p className="fi-text">
            Hỗ trợ sửa chữa điện lạnh tại Đồng Nai, Long An, Bình Dương ...
          </p>

          <a style={{ textDecoration: "none" }} href="/privacy">
            <h3 className="fi-heading fi-heading--mt">
              Chính sách bảo mật thông tin
            </h3>
          </a>
        </div>

        {/* Cột 3: Giới thiệu */}
        <div className="fi-col">
          <h3 className="fi-heading">Giới thiệu về Thuận Điện Lạnh Sài Gòn</h3>

          <p className="fi-text">
            Được tin tưởng và được giới thiệu bởi nhiều khách hàng, Trung tâm
            Điện Lạnh Sài Gòn tự hào là đơn vị cung cấp các dịch vụ điện lạnh,
            điện máy, điện tử chuyên nghiệp và uy tín hàng đầu tại Việt Nam.
          </p>

          <p className="fi-text">
            Chúng tôi là nhà cung cấp dịch vụ chuyên nghiệp trong việc bảo trì,
            sửa chữa, và lắp đặt các thiết bị gia dụng như máy lạnh, máy giặt,
            tủ lạnh, lò vi sóng, máy nước nóng lạnh, tivi, loa, amply, máy hút
            mùi, máy may, máy rửa bát, máy hủy giấy, máy chạy bộ và máy massage.
          </p>
        </div>
      </div>
    </section>
  );
}
